export const EventBus = new Vue()


// WEBPACK FOOTER //
// ./scripts/vue/event-bus.js